
import { Stack, Typography, FormControl, Select, MenuItem } from '@mui/material';

import QuickStartErrorText from '../common/errorText';

interface DepartmentDropdownObject {
  id: number;
  name: string;
}

interface DepartmentSelectionProps {
  isLoading: boolean;
  error: {
    errorType: boolean;
    message: string;
  },
  list: DepartmentDropdownObject[];
  value: string;
  setValue: (value: string) => void;
  fielderror: string;
}

const DepartmentSelection = ({ isLoading, error, list, value, setValue, fielderror }: DepartmentSelectionProps) => {


  return (
    <Stack flexGrow={1}>
      <Stack direction='row' alignItems='center' sx={{
        border: '1px solid #D1D1D1',
        borderRadius: '6px',
        paddingX:'16px',
        '&:focus-within': {
          border: '1px solid #000000',
        },
      }}>
        <FormControl
          variant='standard'
          fullWidth
          sx={{
            width:'100%',
            '& .MuiFormLabel-root': {
              fontFamily: 'Schibsted Grotesk',
              fontSize: '16px',
              fontWeight: 400,
              textAlign: 'left',
              color: '#000000',
            },
            '& .MuiSelect-select': {
              paddingTop: '16px!important',
            },
            '& .MuiInput-input:focus': {
              backgroundColor: 'white',
            },
          }}>
          <Select
            IconComponent={() => (<></>)}
            disabled={isLoading || error.errorType}
            sx={{
              padding: '4px 0px',
              backgroundColor: 'transparent',
              ...(value.length > 0 && 
              {
                '& .MuiFormLabel-root': {
                  fontSize: '12px',
                  color:'black',
                },
                backgroundColor: 'white!important',
                '&:hover': {
                  backgroundColor: 'white',
                },
              }
              ),
            }}
            disableUnderline = {true}
            value={value}
            onChange={(e) => setValue(e.target.value)}>
            {Array.isArray(list) && list.length > 0 &&
          list?.map(({ id, name }) => {
            return (
              <MenuItem key={id} value={id}>
                <Typography
                  sx={{
                    fontFamily: 'Schibsted Grotesk',
                    fontsize: '14px',
                    color: 'black',
                    fontweight: 400,
                    lineHeight: '17px',
                    letterspacing: '0em',
                    textalign: 'left',
                  }}
                  variant='body2'
                  className='role-menuitem'
                >
                  {name}
                </Typography>
              </MenuItem>
            );
          })
            };
          </Select>
        </FormControl>
      </Stack>
      {fielderror !== '' && <QuickStartErrorText error={fielderror} />}
    </Stack>
  );
};

export default DepartmentSelection;